(function casaPageEditorial(){
  'use strict';

  /* ---------------- SELL: what actually happens to your piece ---------------- */
  // The Sell page had a four-icon "Submit / Review / Ship / Get Paid" strip and a
  // payout table. Neither answers the question a consignor is actually asking,
  // which is "what happens to my bag once it leaves my hands, and when exactly do
  // I get paid". Every number below comes from the Consignor Terms.
  var JOURNEY = '' +
    '<section class="casa-journey" aria-labelledby="journey-h">' +
      '<div class="container">' +
        '<div class="head">' +
          '<span class="eyebrow">Before You Send Anything</span>' +
          '<h2 id="journey-h">What happens to your piece</h2>' +
          '<p class="lead">Handing over something valuable deserves a straight answer about what comes next. ' +
            'This is the whole process, including the parts most consignment houses leave vague.</p>' +
        '</div>' +
        '<div class="casa-steps">' +

          '<div class="casa-step"><div class="n">01</div><div>' +
            '<h3>You tell us what you have</h3>' +
            '<p>Photographs, condition as you see it, and what you hope to get. A specialist reads it — not a form ' +
              'and not a queue — and replies within two business days.</p>' +
            '<p class="fine">Nothing is committed at this stage, and there is no fee for asking.</p>' +
          '</div></div>' +

          '<div class="casa-step"><div class="n">02</div><div>' +
            '<h3>We make you an offer in writing</h3>' +
            '<p>If we want the piece, you receive an Offer Summary stating the commission rate for that specific ' +
              'item and what you would keep. You see your payout before you agree to anything.</p>' +
            '<p class="fine">The rate in your Offer Summary is the rate that governs — not a range on a web page.</p>' +
          '</div></div>' +

          '<div class="casa-step"><div class="n">03</div><div>' +
            '<h3>You ship it insured, on us</h3>' +
            '<p>We send a prepaid, insured label. Until we receive and accept the piece it remains yours, and the ' +
              'risk in transit sits with you — which is exactly why the label is insured rather than just tracked.</p>' +
          '</div></div>' +

          '<div class="casa-step"><div class="n">04</div><div>' +
            '<h3>We inspect and authenticate it</h3>' +
            '<p>Hardware, stitching, leather, date codes, provenance. We may decline a piece that fails ' +
              'authentication or condition standards, or that is not as described — and if we do, it comes back to you.</p>' +
            '<p class="fine">If the piece is not as described we may revise the offer. You get five business days to ' +
              'accept or decline, and at least one reminder. Silence is never treated as acceptance of a lower payout.</p>' +
          '</div></div>' +

          '<div class="casa-step"><div class="n">05</div><div>' +
            '<h3>We photograph, price and list it</h3>' +
            '<p>Casa sets the listing price from market data and the item’s condition, and may adjust it over the ' +
              'consignment period. Photography, authentication, condition assessment and listing preparation are all ' +
              'at our expense.</p>' +
            '<p class="fine">Our commission is our only compensation. There is no upfront fee, no authentication fee ' +
              'and no per-item processing fee — not for members, not for anyone.</p>' +
          '</div></div>' +

          '<div class="casa-step"><div class="n">06</div><div>' +
            '<h3>It sells, and then you are paid</h3>' +
            '<p>A sale is finalised once we have the proceeds in full and the buyer’s return window has closed ' +
              'without a return or a chargeback — typically about 25 days after the piece sells. We pay you within ' +
              '30 days of that point, by ACH transfer or cheque.</p>' +
            '<p class="fine">We do not hold balances on your behalf. Every payout is disbursed directly to you.</p>' +
          '</div></div>' +

          '<div class="casa-step"><div class="n">07</div><div>' +
            '<h3>If you change your mind</h3>' +
            '<p>You can ask for any unsold piece back at any time, in writing. A return fee of $50 shipping plus ' +
              '$150 processing applies per item, and we ship it within fifteen days.</p>' +
            '<p class="fine">If <em>we</em> ask you to take a piece back, no return fee applies. Full terms are in the ' +
              '<a class="lnk-consignor-terms" style="color:var(--navy);text-decoration:underline;cursor:pointer;">Consignor Terms of Service</a>.</p>' +
          '</div></div>' +

        '</div>' +
      '</div>' +
    '</section>';

  /* ---------------- ABOUT: the standards, stated plainly ---------------- */
  // Deliberately about the PRACTICE, not the people. Writing a founder biography
  // would mean inventing things about Alexa, and a fabricated origin story is
  // exactly the kind of detail that unravels in a category built on provenance.
  var STANDARDS = '' +
    '<section class="casa-standards" aria-labelledby="standards-h">' +
      '<div class="container">' +
        '<span class="eyebrow">Our Standards</span>' +
        '<h2 id="standards-h">How we actually work</h2>' +
        '<dl>' +
          '<dt>Every piece is examined by a person</dt>' +
          '<dd>Authentication here is hardware, stitching, leather grain, date codes and provenance, assessed by ' +
            'specialists rather than by an app. If a piece cannot be verified to our standard, it does not get listed — ' +
            'and if you buy something and believe it is not authentic, tell us within five days of delivery and a full ' +
            'refund of the purchase price and original shipping is yours on return of the item.</dd>' +

          '<dt>Condition is described honestly, including when it is not perfect</dt>' +
          '<dd>Pre-owned means used, and a grade alone tells you nothing. Every listing explains what its condition ' +
            'grade actually means for that piece — including the ones sold as-is, where we would rather answer ten ' +
            'questions before a sale than have a piece come back as a surprise. Pieces are designated Final Sale, so it ' +
            'matters that you know what you are buying — though your order can be cancelled within an hour, and the ' +
            'authenticity guarantee is separate from Final Sale: if you believe a piece is not authentic, ' +
            'tell us within 5 days of delivery and we refund it in full.</dd>' +

          '<dt>We carry the risk until the piece reaches you</dt>' +
          '<dd>Every order ships fully insured, signature required, within the United States. Risk of loss stays with ' +
            'Casa until the piece is delivered — not until it is handed to a carrier. Shipping is charged as a flat ' +
            'amount based on the order value, typically one to two per cent, because insuring a five-figure handbag ' +
            'is our cost to carry, not a surcharge to pass to you.</dd>' +

          '<dt>The terms are written by a lawyer and shown before you agree</dt>' +
          '<dd>Buying, consigning and membership each have their own agreement, drafted by counsel and presented in ' +
            'full at the point it applies — not buried in a footer. When you accept one, we record what you agreed ' +
            'to, which version, and when. You can read all of them at any time under ' +
            '<a class="lnk-terms-of-service" style="color:var(--navy);text-decoration:underline;cursor:pointer;">Legal Information &amp; Disclaimers</a>.</dd>' +

          '<dt>We are independent</dt>' +
          '<dd>Casa Consignment is not affiliated with, sponsored by, or endorsed by any of the houses whose pieces we ' +
            'resell. We name them because that is what the pieces are; every trademark belongs to its owner.</dd>' +
        '</dl>' +
      '</div>' +
    '</section>';

  function inject(){
    // Sell: after the payout tiers, where a consignor is already reading numbers
    // and the obvious next question is "and then what".
    try {
      var sell = document.getElementById('view-sell');
      if (sell && !sell.querySelector('.casa-journey')) {
        var anchor = sell.querySelector('.tiers-wrap');
        if (anchor && anchor.parentNode) {
          anchor.insertAdjacentHTML('afterend', JOURNEY);
        } else {
          sell.insertAdjacentHTML('beforeend', JOURNEY);
        }
      }
    } catch(e){}

    // About: after the existing three-card story block.
    try {
      var about = document.getElementById('view-about');
      if (about && !about.querySelector('.casa-standards')) {
        var grid = about.querySelector('.about-grid');
        if (grid && grid.parentNode) {
          // The membership section is also anchored to .about-grid, so append after
          // whichever sibling currently sits last rather than fighting over the slot.
          var host = grid.parentNode;
          var mem = host.querySelector('.casa-membership');
          (mem || grid).insertAdjacentHTML('afterend', STANDARDS);
        } else {
          about.insertAdjacentHTML('beforeend', STANDARDS);
        }
      }
    } catch(e){}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
  // The membership block and the payout calculator are injected by later scripts,
  // so re-run to land in the right place once the page has settled.
  setTimeout(inject, 1200); setTimeout(inject, 2800);

  console.log('  ✓ Page editorial: Sell "what happens to your piece" (grounded in the Consignor Terms) + About "how we actually work"');
})();
